// extracted by mini-css-extract-plugin
export default {"cloneModal":"CloneModal_cloneModal__sY50F","dialog":"CloneModal_dialog__6abzm","cancelButton":"CloneModal_cancelButton__g67fe"};